import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SectionHeading } from "../Section";
import { Reveal } from "../Reveal";
import { STOCK, CLINIC_PHOTOS } from "../../data/site";

const CARDS = [
  {
    title: "Physiotherapy",
    image: STOCK.physioManual,
    desc: "Personalized physiotherapy and rehabilitation programs designed to reduce pain, restore movement, improve strength and help patients return to an active life.",
    items: ["Home Visit Physiotherapy", "Pain Management", "Orthopedic Physiotherapy", "Back & Neck Pain", "Joint Pain & Arthritis Care", "Sports Injury Rehabilitation", "Post-operative Rehabilitation", "Neurological Rehabilitation", "Pediatric Physiotherapy", "Exercise Therapy", "Cupping Therapy", "Dry Needling Therapy"],
    to: "/physiotherapy",
    cta: "Explore Physiotherapy",
    accent: "teal",
  },
  {
    title: "Speech & Hearing",
    image: CLINIC_PHOTOS.hearingCare,
    desc: "Professional speech, language and hearing services for children and adults, with individualized assessment and therapy.",
    items: ["Speech Therapy", "Language Therapy", "Pediatric Speech Therapy", "Speech & Communication Disorders", "Stammering / Stuttering Support", "Voice Therapy", "Hearing Assessment", "Audiology Services", "Hearing Rehabilitation", "Communication Support"],
    to: "/speech-hearing",
    cta: "Explore Speech & Hearing",
    accent: "indigo",
  },
];

export const TwoServices = () => (
  <section className="py-24 md:py-32 bg-white" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading center overline="Our Specialized Care" title="Two Departments, One Trusted Clinic" subtitle="From movement and rehabilitation to speech, language and hearing — comprehensive care under one roof." />

      <div className="mt-16 grid gap-8 lg:grid-cols-2">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.1}>
            <div
              data-testid={`service-card-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group relative flex h-full flex-col overflow-hidden rounded-[2.25rem] border border-dash-line bg-dash-bg shadow-[0_10px_40px_rgb(10,37,64,0.05)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_40px_70px_rgb(10,37,64,0.12)]"
            >
              <div className="relative h-64 overflow-hidden">
                <img src={c.image} alt={c.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-dash-ink/80 via-dash-ink/20 to-transparent" />
                <h3 className="absolute bottom-5 left-6 font-display text-3xl font-bold text-white">{c.title}</h3>
              </div>

              <div className="flex flex-1 flex-col p-7 md:p-9">
                <p className="text-dash-muted leading-relaxed">{c.desc}</p>

                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-2.5">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-start gap-2 text-sm text-dash-ink">
                      <Check className={`h-4 w-4 shrink-0 mt-0.5 ${c.accent === "teal" ? "text-dash-teal" : "text-dash-indigo"}`} />
                      {it}
                    </li>
                  ))}
                </ul>

                <Link
                  to={c.to}
                  data-testid={`service-cta-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={`mt-8 inline-flex items-center gap-2 self-start rounded-full px-6 py-3.5 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 ${c.accent === "teal" ? "bg-dash-teal hover:bg-dash-ink" : "bg-dash-indigo hover:bg-dash-ink"}`}
                >
                  {c.cta}
                  <ArrowUpRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
